import request from '../../../helpers/request';

const editRoomComment = async (comment, room) => {
  await request.put(
    `/RentPlace/rental_house/office`,
    {
      ...room,
      comment,
    },
    'При редактировании комментария произошла ошибка'
  );
};

export default editRoomComment;
